import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import logger from "../../Utils/logger";
const truncateText = (text = "", limit = 15) =>
  text.length > limit ? `${text.substring(0, limit)}...` : text;

export default function QuickPurchaseCards({ digitalSuggestionItems = [] ,increaseQuantity,decreaseQuantity}) {
  logger.log("digitalSuggestionItems in QuickPurchaseCards", digitalSuggestionItems);
  const navigate = useNavigate();
    return (
    <Box style={{ paddingRight: "10px", paddingLeft: "10px" }}>
      <Box
        sx={{
          borderRadius: 3,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 14, md: 14 },
              fontWeight: 600,
              color: "#3A5075",
            }}
          >
            More Cards For Quick Purchases
          </Typography>

        <Typography
  onClick={() =>
    navigate("/items?machineId=8&showItems=true&isDigital=true", {
      state: {
        digitalSuggestionItems,
      },
    })
  }
  sx={{
    fontSize: { xs: 13, md: 13 },
    color: "#73829B",
    cursor: "pointer",
  }}
>
  View all
</Typography>
        </Box>

        {/* Scrollable Cards */}
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            overflowX: "auto",
            pb: 1,
            pr: 1,
            pl: 1,
            "&::-webkit-scrollbar": {
              height: 6,
            },
            "&::-webkit-scrollbar-thumb": {
              bgcolor: "#ccc",
              borderRadius: 10,
            },
          }}
        >
          {digitalSuggestionItems?.map((item,index) => (
            <Card
              key={item.slot_id}
              sx={{
                flexShrink: 0,
                borderRadius: 4,
                boxShadow: "0px 4px 16px rgba(0,0,0,0.08)",
                minWidth: 140,
                maxWidth: 140,
              }}
            >
              <Box
                sx={{
                  p: 2,
                  textAlign: "center",
                  position: "relative",
                }}
              >
                {/* Add Button */}
                {item.mycount>0?
                <Button
                  style={{
                    width: "60px",
                    height: "22px",
                    maxWidth: "60px",
                    minWidth: "60px",
                    position: "absolute",
                    top: 70,
                    right: 8,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  variant="outlined"
                  sx={{
                    borderColor: "#00B26B",
                    color: "#00B26B",
                    borderRadius: "5px",
                    textTransform: "none",
                    fontSize: 9,
                    p: 0,
                  }}
               
                >
                  <RemoveIcon sx={{ fontSize: 14 }} onClick={(e) => decreaseQuantity(e, index, item.slot_id, item.mycount,"remove")}   />
                  <span style={{fontSize:"14px"}}>{item.mycount}</span>
                  <AddIcon sx={{ fontSize: 14 }}   onClick={(e) => increaseQuantity(e, index, item.slot_id, item.mycount,"add")} />
                </Button>: <Button
                  style={{
                    width: "60px",
                    height: "22px",
                    maxWidth: "60px",
                    minWidth: "60px",
                    position: "absolute",
                    top: 70,
                    right: 8,
                    display: "flex",
                    justifyContent: "center",
                  }}
                  variant="outlined"
                  sx={{
                    borderColor: "#00B26B",
                    color: "#00B26B",
                    borderRadius: "5px",
                    textTransform: "none",
                    fontSize: 9,
                    p: 0,
                  }}
                 onClick={(e) => increaseQuantity(e, index, item.slot_id, item.mycount,"add")}
                >
                <span style={{ fontSize: "14px" }}>Add</span>
                </Button>}

                {/* Product Image */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Box
                    component="img"
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${item.image_path}`}
                    alt={item.mv_name}
                    sx={{
                      width: "69px",
                      height: "51px",
                      objectFit: "contain",
                      mb: 2,
                    }}
                  />
                </Box>
              </Box>

              <CardContent
                sx={{
                  py: 0,
                }}
              >
                <Typography
                  sx={{
                    fontSize: 8,
                    fontWeight: 600,
                    color: "#3A5075",
                    mb: 1,
                    textAlign: "center",
                  }}
                >
                  Item Left. {item.active_count}
                </Typography>

                <Typography
                  title={item.mv_name}
                  sx={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: "#3A5075",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {truncateText(item.mv_name, 18)}
                </Typography>

                <Typography
                  title={item.mv_description}
                  sx={{
                    fontSize: 10,
                    color: "#8A94A6",
                    mb: 1,
                    minHeight: "28px",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {truncateText(item.mv_description || "", 40)}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 10,
                      fontWeight: 700,
                      color: "#65748B",
                    }}
                  >
                    ₹ {Number(item.offer_price || 0).toFixed(2)}
                  </Typography>

                  {item.mrp > item.offer_price && (
                    <Typography
                      sx={{
                        fontSize: 6,
                        color: "#A0AEC0",
                        textDecoration: "line-through",
                      }}
                    >
                      ₹ {Number(item.mrp).toFixed(2)}
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  );
}